var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.isTimeout && _vm.isShow && !_vm.isManualShooted)?_c('div',{staticClass:"camera-message-box",class:{
    isPC: _vm.$store.getters['camera/isPC'],
    isI18nJa: _vm.$i18n.locale == 'ja',
    isI18nVi: _vm.$i18n.locale == 'vi',
    isI18nEn: _vm.$i18n.locale == 'en',
    isI18nId: _vm.$i18n.locale == 'id',
    isI18nMs: _vm.$i18n.locale == 'ms',
    isI18nTh: _vm.$i18n.locale == 'th',
    isI18nZh: _vm.$i18n.locale == 'zh'
  },style:({ top: `${_vm.top}px` })},[_c('div',{staticClass:"message-box"},[_c('div',{staticClass:"message-box-message"},_vm._l((_vm.$store.state.camera.i18nKeyShootDescriptionArray),function(description,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(description)+" ")])}),0)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }